
export default function LoadingComponent() {
  const header_logo = (
    <svg
      className="header-logo"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="2" y1="12" x2="22" y2="12"></line>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </svg>
  );
  const loading_icon = (
    <svg viewBox="0 0 16 16" version="1.1">
      {/* <rect width="16" height="16" id="icon-bound" fill="currentColor" /> */}
      <path fill="currentColor" d="M14,0v2.709C12.534,1.047,10.391,0,8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8h-2c0,1.603-0.625,3.109-1.756,4.244 S9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C12.322,3.834,12.4,3.916,12.472,4H10v2h6V0H14z" />
    </svg>
  );
  return (
      <div className="loading-wrapper">
        <div className="loading-inner">
          <div className="loading-logo">
            <h1>{header_logo} Parry News</h1>
          </div>
          <div className="loading-spinner">
          {loading_icon}
          <p>Loading...</p>
          </div>
        </div>
      </div>
  );
}
